// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_TimelineInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /dashboards/operacao_service_orders/timeline
 *
 * Validates the bucket query parameter for timeline bucketing.
 */
import { registerContract } from './validate'

export interface OperacaoServiceOrders_TimelineInput {
bucket?: string
}

registerContract('OperacaoServiceOrders_TimelineInput', {
  bucket: { type: 'string',  required: false },
})
